import React from "react";

import { resourcesPrimaryModule } from "../../constants";
import * as S from "./styled";

const ResourcesPrimaryModule = () => (
  <S.Container>
    {resourcesPrimaryModule.map(item => (
      <S.Card key={item.href}>
        <S.Link href={item.href}>{item.title}</S.Link>
        <S.Image alt="" src={item.image} />
        <S.Content>
          <S.Title>{item.title}</S.Title>
          <S.Description>{item.description}</S.Description>
        </S.Content>
      </S.Card>
    ))}
  </S.Container>
);

export default ResourcesPrimaryModule;
